import { DateTime } from 'luxon'

const getPeriodsForTime = (periods, time) => {
  let array = []
  for (let period of periods) {
    if (period.Start <= time && period.Stop > time) {
      array.push(period.xp_Key)
    }
  }


  if (!array.length) {
    let groups = {};

    for (let period of periods) {
      const group = period.xp_eat_group
      if (!group) continue

      if (!groups.hasOwnProperty(group)) {
        groups[group] = [period]
      } else {
        groups[group].push(period)
      }
    }


    for (let group in groups) {
      array.push(findMinDiffPeriod(groups[group], time))
    }
  }

  return array
}

function findMinDiffPeriod(periods, time) {
  let minDif = Number.MAX_SAFE_INTEGER
  let minDifPeriod

  for (let period of periods) {
    const periodMins = period.Start.hour * 60 + period.Start.minute
    const timeMins = time.hour * 60 + time.minute
    const dif = periodMins - timeMins

    if (dif >= 0 && dif < minDif) {
      minDif = dif
      minDifPeriod = period.xp_Key
    }
  }

  if (!minDifPeriod) {
    minDifPeriod = periods[periods.length - 1].xp_Key
  }

  return minDifPeriod
}

const parsePeriodsDates = periods => {
  const formatMask = 'd.MM.yyyy H:mm:ss'
  const formattedPeriods = periods.map(a => ({
    ...a,
    Start: DateTime.fromFormat(a.Start, formatMask),
    Stop: DateTime.fromFormat(a.Stop, formatMask),
  }));

  return formattedPeriods
};

const getNext = (array, value) => {
  const index = array.indexOf(value);
  if (!!~index) {
    if (index < array.length - 1) {
      return array[index + 1]
    } else {
      return array[0]
    }
  } else {
    return array[0]
  }
};

const formatTime = time => {
  const formattedDate = time.setLocale('ru').toFormat('cccc DDD')
  const dateValue =
    formattedDate.charAt(0).toUpperCase() +
    formattedDate.slice(1).replace(' г.', '')
  const timeValue = time.setLocale('ru').toFormat('T')

  return { dateValue, timeValue }
}

const getDishesPhotoIds = menu => {
  return menu.filter(a => a && a.hasPhoto === '1').map(a => a.xp_Key)
}

const getVersion = async () => {
  try {
    const response = await fetch('version.txt')
    const version = await response.text()
    return version
  } catch (e) {
    console.log(e)
  }
}

const isHTML = str => {
  var doc = new DOMParser().parseFromString(str, 'text/html')
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1)
}

const getClientIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org/?format=json')
    const data = await response.json()
    return data.ip
  } catch (e) {
    console.log(e)
  }
}

const getLocalIP = () => {
  var ip = false
  window.RTCPeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection ||
    false

  if (window.RTCPeerConnection) {
    ip = []
    var pc = new RTCPeerConnection({ iceServers: [] }),
      noop = function() {}
    pc.createDataChannel('')
    pc.createOffer(pc.setLocalDescription.bind(pc), noop)

    pc.onicecandidate = function(event) {
      if (event && event.candidate && event.candidate.candidate) {
        var s = event.candidate.candidate.split('\n')
        ip.push(s[0].split(' ')[4])
      }
    }
  }

  return ip
}

export {
  getPeriodsForTime,
  parsePeriodsDates,
  getNext,
  formatTime,
  getDishesPhotoIds,
  getVersion,
  isHTML,
  getClientIP,
  getLocalIP,
}
